import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionPaperStyle = makeStyles((theme: Theme) =>
  createStyles({
    TransactionDate: {
      color: "#545454",
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightRegular,
    },
    pending: {
      color: theme.palette.secondary.main,
      fontWeight: "bold",
      fontSize: "12px",
    },
    rightContent: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    leftContent: {
      display: "flex",
    },
    valueText: {
      fontSize: "16px",
      fontWeight: 600,
      marginRight: "14px",
      paddingBottom: "4px",
    },
    icon: {
      alignSelf: "end",
      paddingTop: "4px",
      paddingRight: "8px",
    },
    title: {
      fontSize: "16px",
      fontWeight: 600,
      color: "#252525",
      marginTop: "2px",
    },
    time: {
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#545454",
      marginBottom: "4px",
    },
    date: {
      fontSize: "12px",
      fontWeight: theme.typography.fontWeightRegular,
      color: "#545454",
      marginBottom: "4px",
    },
    content: {
      padding: "8px 0px",
      // border: "1px solid red",
    },
  }),
);
